import { createContext } from "react";

const NameChangesContext = createContext();

export default NameChangesContext;
